<i18n locale="en">
{
  "labels": {
    "button": "Button label",
    "destination": "Destination"
  },
  "destinations": {
    "order": "Online ordering",
    "gift-card": "Gift cards",
    "catering": "Catering page",
    "catering-menu": "Catering menu"
  }
}
</i18n>

<template>
  <div class="flex-col gap-8">
    <OwnInputContainer :label="t('labels.button')">
      <OwnInput v-model="label" data-testid="cta-button-label-input" />
    </OwnInputContainer>
    <OwnInputContainer :label="t('labels.destination')">
      <OwnSegmentedControl
        v-model="link"
        :options="destinationOptions"
        data-testid="cta-button-destination-options"
      />
    </OwnInputContainer>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { useI18n } from 'vue-i18n'
import { mapGetters } from 'vuex'

import { OwnInput } from '@/ui/OwnInput'
import { OwnInputContainer } from '@/ui/OwnInputContainer'
import { OwnSegmentedControl } from '@/ui/OwnSegmentedControl'

import { CTAButtonCommands } from '../commands/CTAButtonCommands'

export default {
  name: 'CTAButtonEditor',
  components: { OwnInput, OwnInputContainer, OwnSegmentedControl },
  props: { id: { type: String, required: true } },
  setup() {
    const { t } = useI18n()
    return { t }
  },
  data() {
    return {
      hydrated: false,
      label: '',
      link: 'order',
      destinationOptions: [
        'order',
        'gift-card',
        'catering',
        'catering-menu',
      ].map((value) => ({ label: this.t(`destinations.${value}`), value })),
    }
  },
  computed: {
    ...mapGetters({ blockById: 'emailBuilder/blockById' }),
    currentBlock() {
      return this.blockById(this.id)
    },
  },
  watch: {
    label(label) {
      if (this.hydrated && label.trim()) this.saveLabel(label)
    },
    async link(link) {
      if (!this.hydrated) return
      await CTAButtonCommands.updateBlock({
        targetId: this.id,
        update: { data: { label: this.label, link } },
      })
    },
  },
  created() {
    this.label = this.currentBlock?.data?.label ?? 'Order now'
    this.link = this.currentBlock?.data?.link ?? 'order'
    this.saveLabel = debounce(async (label) => {
      await CTAButtonCommands.updateBlock({
        targetId: this.id,
        update: { data: { label, link: this.link } },
      })
    }, 500)
    this.$nextTick(() => {
      this.hydrated = true
    })
  },
  beforeUnmount() {
    this.saveLabel.flush()
  },
}
</script>
